Homepage = {

    init: function (PAGE) {


    	PAGE = PAGE ? PAGE : $('body');
		this.el = PAGE.find('[page="homepage"], .content.homepage');

        // console.log('Homepage.init');
        // console.log(PAGE, this.el, this.el.length);

		if(!this.el.length) return;

        this.show();

        // this.injectSVG(this.el.find('img'));

        // this.initForm();
       
    },

    show:function(){
        if(this.el.attr('visibility') == "hidden"){
            this.el.attr('visibility', "visible")
        }
    },

    initForm:function(){
        initAjaxForms();
        this.el.find('.buy').unbind('click')
            .click(function(event) {
                if($(this).is('.selected')){
                    $(this).siblings('[data-class="forms"]').slideUp(300);
                    $(this).removeClass('selected').find('span').text('Objednať');
                } else {
                    $(this).siblings('[data-class="forms"]').slideDown(500);
                    $(this).addClass('selected').find('span').text('Zavrieť');
                }
            });
    },

    reset: function(){
        Page.load($('[page="homepage"]'), "");
    },

    injectSVG: function(SVG){

        var injectorOptions = {
          evalScripts: 'once',
        };

        SVGInjector(SVG, injectorOptions, function (totalSVGsInjected) {
          Popup.animate(SVG);
        });
    },
}
